import firebase from "firebase/app";
import "firebase/firestore";

var firebaseConfig = {
    apiKey: "AIzaSyAYgbNT6xdTghEnBsrndr5esu5Oo-sURVE",
    authDomain: "disneylandweather-9e91e.firebaseapp.com",
    projectId: "disneylandweather-9e91e",
    storageBucket: "disneylandweather-9e91e.appspot.com",
    messagingSenderId: "805148558831",
    appId: "1:805148558831:web:8b3d07a12388ec1deee21a",
    measurementId: "G-ZVZ3PYVTZZ"
  };
  
    // Initialize Firebase
    const firebaseApp = firebase.initializeApp(firebaseConfig);
    // firebase.analytics();
    export default firebaseApp.firestore();
